<template>
  <div class="home">
    <div class="home-head">
      <div class="home-head-search mask" v-if="showMask" @click="clickMask">
        <van-icon name="search" size="25" /><span>有问题，搜一搜</span>
      </div>
      <div class="home-head-search">
        <van-field
          id="search"
          v-model="keyWord"
          placeholder="有问题，搜一搜"
          left-icon="search"
          size="25"
          @input="onSearch"
          @blur="onBlur"
          clearable
        />
        <div
          class="home-head-search-cancel"
          @click="
            showMask = true;
            keyWord = '';
          "
        >
          取消
        </div>
      </div>
    </div>
    <div class="home-list" v-if="list && (showMask || !keyWord)">
      <div v-for="(item, index) in list" :key="index">
        <van-cell
          :value="item.showName"
          :icon="item.iconUrl"
          is-link
          :arrowDirection="item.isRight ? 'down' : 'up'"
          @click="changeArrow(item)"
        />
        <div v-if="!item.isRight">
          <div
            v-for="child in item.children"
            :key="child.id"
            class="child"
            @click="toDetail(child.id)"
          >
            {{ child.showName }}
          </div>
        </div>
      </div>

      <van-cell
        class="service"
        is-link
        @click="handleToLicence"
        v-if="showLicence"
      >
        营业执照
      </van-cell>

      <van-cell
        class="service"
        is-link
        @click="handleToBusinessPermits"
        v-if="showBusinessPermits"
      >
        食品经营许可证
      </van-cell>

      <van-cell
        class="service"
        is-link
        v-if="showService"
        @click="toOnlineService"
      >
        联系客服
      </van-cell>
    </div>
    <div v-if="!showMask && searchData && keyWord" class="home-result">
      <div v-if="searchData && keyWord" class="home-result-tip">
        关于“{{ keyWord }}”的搜索结果，共{{ searchData.length }}条
      </div>
      <div
        v-for="searchItem in searchData"
        :key="searchItem.id"
        class="home-result-li"
        @click="toDetail(searchItem.id)"
      >
        <div>{{ searchItem.showName }}</div>
        <div class="detail">{{ searchItem.detailPreview }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { Field, Icon, Cell } from "vant";
import { getAllHelpData, getSearchHelpData } from "../../services/request.js";
import debounce from "lodash/debounce";
import { validuser } from "../../utils/validuser.js";
import signIn from "../../utils/signIn.js";
import { OnlineService } from "@freshservice/bridge";
import { IS_PRO } from "@fresh/env";
import Device from "@sh/device-detector";
const device = new Device();
import { parseJson } from "../../utils/utils";

export default {
  data() {
    return {
      keyWord: "", //关键词
      showMask: true,
      list: undefined,
      searchData: [],
      showService: device.in("ShiHangApp"),
      showLicence: false,
      showBusinessPermits: false
    };
  },
  components: {
    "van-field": Field,
    "van-icon": Icon,
    "van-cell": Cell
  },
  created() {
    this.getAllHelpData();
  },
  watch: {
    "$route.query"() {
      if (this.$route.query.token) {
        window.location.reload();
      }
    }
  },
  methods: {
    clickMask() {
      this.showMask = false;
      document.getElementById("search").focus();
    },
    async getAllHelpData() {
      try {
        const res = await getAllHelpData();
        if (res && res.Data) {
          this.list = res.Data.map(item => {
            return {
              isRight: true,
              ...item
            };
          });

          this.list.forEach(item => {
            if (item && item.children.find(i => i.id === 67)) {
              this.showLicence = true;
            }
            if (item && item.children.find(i => i.id === 68)) {
              this.showBusinessPermits = true;
            }
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    toDetail(id) {
      this.$router.push({
        name: "detail",
        query: {
          id: id,
          isHelp: 1
        }
      });
    },
    onSearch: debounce(
      function(val) {
        if (val == "") {
          return;
        }
        if (val.match(/^idebug:\/\/.*/gi)) {
          let url = val.split("idebug://")[1];
          window.location.href = url + "?newwindow=1";
          return;
        }
        this.getSearchHelpData();
      },
      300,
      { leading: false, trailing: true }
    ),
    async getSearchHelpData() {
      try {
        const res = await getSearchHelpData(this.keyWord);
        if (res && res.Data) {
          this.searchData = res.Data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    changeArrow(item) {
      this.list.filter(i => {
        i.isRight = i.id === item.id ? !i.isRight : true;
      });
    },
    handleToLicence() {
      this.toDetail(67);
    },
    handleToBusinessPermits() {
      this.toDetail(68);
    },
    toOnlineService() {
      // 未登录先去登陆
      if (!validuser()) {
        setTimeout(() => {
          signIn();
        }, 1500);
        return;
      }
      const token = parseJson(window.localStorage.getItem("TOCTOKEN"));
      const params = {
        test: !IS_PRO,
        CustomerGuid: token && token.CustomerGuid ? token.CustomerGuid : ""
      };
      OnlineService.init(params).execute();
    },
    onBlur() {
      // this.showMask = true;
      // this.keyWord = ''
    }
  }
};
</script>
<style lang="scss">
.home {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f8f8f8;
  height: 100%;
  min-height: 100vh;
  font-size: 14px;
  &-head {
    padding: 16px;
    width: 100%;
    box-sizing: border-box;
    background-color: #e8e8e8;
    position: relative;
    &-search {
      display: flex;
      align-items: center;

      &-cancel {
        white-space: nowrap;
        color: #00a654;
        margin-left: 10px;
      }
    }
    .mask {
      padding: 10px 16px;
      background-color: #fff;
      border-radius: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      z-index: 1;
      width: 83%;
    }
    .van-cell {
      .van-cell__value {
        margin-left: 5px;
        font-size: 16px;
      }
    }
  }
  &-list {
    width: 100%;
    .child {
      padding: 10px 40px;
      font-size: 14px;
      text-align: left;
    }
    .van-icon {
      .van-icon__image {
        width: 3em;
        height: 3em;
        position: absolute;
        top: -50%;
        left: -0.4rem;
      }
    }
    .van-cell {
      .van-cell__value {
        margin-left: 25px;
        font-size: 16px;
      }
    }
    .service {
      margin-top: 20px;
      .van-cell__value {
        margin-left: 0;
        font-size: 16px;
      }
    }
  }
  &-result {
    width: 100%;
    height: 100%;
    background-color: #f4f4f4;
    font-size: 15px;
    &-tip {
      padding: 16px;
    }
    &-li {
      background-color: #fff;
      padding: 16px;
      line-height: 22px;
    }
    .detail {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  .van-field {
    border-radius: 5px;
    .van-field__left-icon {
      .van-icon-search {
        font-size: 25px;
      }
    }
  }
}
</style>
